export default __webpack_public_path__ + "static/media/PhysicalDescriptions_05.db76a634.png";